/* Glass-shine hover sweep on filled buttons. Styles live in button-shine-new.css. */
(function () {
  var ROOTS =
    '#MainContent, .shopify-section-group-footer-group, #cart-drawer, #wishlist-drawer, .shopify-section-group-header-group';
  var CANDIDATES = 'a, button, [role="button"], span[class*="btn"], span[class*="button"]';
  var EXCLUDED =
    'nav, [class*="__nav"], [class*="-nav"], [class*="mega"], .menu-drawer, ' +
    '[class*="pagination"], ' +
    'fieldset, [class*="variant"], [class*="pill"], [class*="swatch"], ' +
    '[role="tab"], [role="tablist"], .tab-btn, [class*="__tab"], ' +
    '[class*="chip"], ' +
    '[data-no-shine], ' +
    // Rolex (.rx) content never gets the shine (Rolex design guidelines).
    '.rx';
  var WRAPPERS = '[class*="buttons"], [class*="btn-row"]';
  var GLINT_CLASS = 'shine-btn__glint';
  var MIN_WIDTH = 80;
  var MIN_HEIGHT = 32;
  var MAX_HEIGHT = 120;
  var LIGHT_LUMINANCE = 0.6;
  var DEBOUNCE_MS = 200;
  var LATE_SCAN_MS = 1500;

  // Once async section CSS has applied (after the late scan), a visible element with no
  // background really has none. Remember it so the hover fallback doesn't mistake a
  // hover-only background for a filled button.
  var settled = false;
  var noBackground = typeof WeakSet === 'function' ? new WeakSet() : null;

  function parseColor(value) {
    var match = value && value.match(/rgba?\(([^)]+)\)/);
    if (!match) return null;
    var parts = match[1].split(/[\s,\/]+/).filter(Boolean).map(parseFloat);
    return { r: parts[0], g: parts[1], b: parts[2], a: parts.length > 3 ? parts[3] : 1 };
  }

  function luminance(color) {
    function channel(v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    }
    return 0.2126 * channel(color.r) + 0.7152 * channel(color.g) + 0.0722 * channel(color.b);
  }

  function hasBackground(style) {
    var bg = parseColor(style.backgroundColor);
    return !!(bg && bg.a > 0) || style.backgroundImage.indexOf('gradient') !== -1;
  }

  function isRadioLabel(el) {
    var label = el.closest('label');
    if (!label) return false;
    var control = label.control || label.querySelector('input');
    return !!(control && control.type === 'radio');
  }

  function isDone(el) {
    return el.classList.contains('shine-btn') && !!el.querySelector(':scope > .' + GLINT_CLASS);
  }

  function insideShineBtn(el) {
    return !!(el.parentElement && el.parentElement.closest('.shine-btn'));
  }

  function qualifies(el, style) {
    if (el.tagName === 'INPUT') return false;
    if (el.matches(WRAPPERS) || insideShineBtn(el)) return false;
    if (style.display === 'none') return false;
    if (!hasBackground(style)) return false;

    var rect = el.getBoundingClientRect();
    if (rect.width < MIN_WIDTH || rect.height < MIN_HEIGHT) return false;
    // Guard against whole-card links (product/collection tiles) that happen to have a background.
    if (rect.height > MAX_HEIGHT || el.querySelector('img, picture, video')) return false;

    if (!el.textContent.trim()) return false;
    if (el.disabled || el.getAttribute('aria-disabled') === 'true') return false;
    if (el.closest(EXCLUDED) || isRadioLabel(el)) return false;
    return true;
  }

  function apply(el, style) {
    el.classList.add('shine-btn');
    if (style.position === 'static') el.classList.add('shine-btn--relative');

    var bg = parseColor(style.backgroundColor);
    el.classList.toggle('shine-btn--on-light', !!(bg && bg.a > 0 && luminance(bg) > LIGHT_LUMINANCE));

    if (!el.querySelector(':scope > .' + GLINT_CLASS)) {
      var glint = document.createElement('span');
      glint.className = GLINT_CLASS;
      glint.setAttribute('aria-hidden', 'true');
      el.appendChild(glint);
    }

    // Let the glint's start position render before enabling the hover rule, so a glint
    // added mid-hover still animates on that same hover.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('shine-btn--ready');
      });
    });
  }

  function check(el) {
    var style = window.getComputedStyle(el);
    if (qualifies(el, style)) {
      apply(el, style);
      return true;
    }
    if (settled && noBackground && el.offsetWidth > 0 && !hasBackground(style)) noBackground.add(el);
    return false;
  }

  function scan() {
    var roots = document.querySelectorAll(ROOTS);
    for (var r = 0; r < roots.length; r++) {
      var candidates = roots[r].querySelectorAll(CANDIDATES);
      for (var i = 0; i < candidates.length; i++) {
        if (!isDone(candidates[i])) check(candidates[i]);
      }
    }
  }

  // Hover/focus fallback: catches buttons that were hidden (inactive slides) or unstyled
  // during every scan. Walks outward so an inner label span doesn't block its button.
  function onPointerEnter(event) {
    var target = event.target;
    if (!target || target.nodeType !== 1 || !target.closest(ROOTS)) return;

    var el = target.closest(CANDIDATES);
    while (el) {
      if (el.classList.contains('shine-btn') || insideShineBtn(el)) return;
      if (!(noBackground && noBackground.has(el)) && check(el)) return;
      el = el.parentElement && el.parentElement.closest(CANDIDATES);
    }
  }

  function isGlint(node) {
    return node.nodeType === 1 && node.classList.contains(GLINT_CLASS);
  }

  // Ignore mutations that only add or remove our own glint spans, so scan() never re-triggers itself.
  function isOwnMutation(mutation) {
    var nodes = Array.prototype.slice.call(mutation.addedNodes).concat(Array.prototype.slice.call(mutation.removedNodes));
    return nodes.length > 0 && nodes.every(isGlint);
  }

  var timer;
  function scheduleScan() {
    clearTimeout(timer);
    timer = setTimeout(scan, DEBOUNCE_MS);
  }

  function onLoad() {
    requestAnimationFrame(scan);
    setTimeout(function () {
      settled = true;
      scan();
    }, LATE_SCAN_MS);
  }

  function init() {
    scan();

    // Many sections load their CSS async (media="print" onload), so rescan once it has applied.
    if (document.readyState === 'complete') {
      onLoad();
    } else {
      window.addEventListener('load', onLoad, { once: true });
    }

    document.addEventListener('pointerover', onPointerEnter, { passive: true });
    document.addEventListener('focusin', onPointerEnter);

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (!isOwnMutation(mutations[i])) {
          scheduleScan();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:section:load', scheduleScan);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
